import React, { useEffect, useState } from "react";
import Auth from "../../utils/AuthUtils";
import { Link } from "react-router-dom";
import webAPI from "../../api/webApi";
import GenderChart from "./charts/GenderChart";
import AgeChart from "./charts/AgeChart";
import RegistrationDataChart from "./charts/RegistrationDataChart";

function Analytics() {
  const image = Auth.getUserDetails("image");

  const [genderData, setGenderData] = useState([]);
  const [ageData, setAgeData] = useState([]);
  const [dailyRegistrationData, setDailyRegistrationData] = useState([]);
  const [topDistrictsData, setTopDistrictsData] = useState([]);
  const [bottomDistrictsData, setBottomDistrictsData] = useState([]);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    const res = await webAPI.dashboard();

    if (res.code === 200) {
      const result = res.data;

      setGenderData(result.genderWiseCount);
      setAgeData(result.ageWiseCount);
      setDailyRegistrationData(result.dailyRegistrations);
      setTopDistrictsData(result.topDistricts);
      setBottomDistrictsData(result.bottomDistricts);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="page-header">
              <div className="row align-items-center ">
                <div className="col-md-4">
                  <h3 className="page-title">Analytics</h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {ageData && ageData.length > 0 && (
            <div className="col-md-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h6 className="mb-0">Age Wise Registration</h6>
                  </div>
                </div>
                <div className="card-body py-0">
                  <AgeChart ageData={ageData} />
                </div>
              </div>
            </div>
          )}

          {genderData && genderData.length > 0 && (
            <div className="col-md-4 d-flex">
              <div className="card w-100">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h6 className="mb-0">Gender Wise Registration</h6>
                  </div>
                </div>
                <div className="card-body py-0">
                  <GenderChart genderData={genderData} />
                </div>
              </div>
            </div>
          )}

          {topDistrictsData && (
            <div className="col-md-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h6 className="mb-0">Top 10 Districts</h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table">
                      <thead className="table-light">
                        <tr>
                          <th>District</th>
                          <th>Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        {topDistrictsData.length > 0 ? (
                          topDistrictsData.map((item, index) => (
                            <tr key={index}>
                              <td>{item.district}</td>
                              <td>{item.count}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="2" className="text-center">
                              No Data
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="row">
          {bottomDistrictsData && (
            <>
              <div className="col-md-3 d-flex">
                <div className="card flex-fill">
                  <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h6 className="mb-0">Bottom 10 Districts</h6>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table">
                        <thead className="table-light">
                          <tr>
                            <th>District</th>
                            <th>Count</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bottomDistrictsData.length > 0 ? (
                            bottomDistrictsData.map((item, index) => (
                              <tr key={index}>
                                <td>{item.district}</td>
                                <td>{item.count}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2" className="text-center">
                                No Data
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-9 d-flex">
                <div className="card flex-fill">
                  <div className="card-header">
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h6 className="mb-0">Registration Date Wise</h6>
                    </div>
                  </div>
                  <div className="card-body py-0">
                    <RegistrationDataChart dailyData={dailyRegistrationData} />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Analytics;
